import { h } from "hyperapp";

import { columnSelector } from "../../common/column-selector/column-selector";
import { actionsOnSelected } from "../../common/list-item-selector/actions-on-seleted";
import { pagination } from "../../common/pagination/pagination";
import { regionLoading } from "../../common/region-loading/region-loading";
import { controls } from "./controls";
import { list } from "./list";

export const main = ({
  actions,
  section,
  state,
  translations,
}): JSX.Element => {
  const {
    categories,
    clientID,
    loadingCategories,
    places: {
      category,
      lastFetch: {
        failed,
        lastFailure,
        reason: { message },
      },
      loadingPlaces,
      pagination: {
        currentPageNumber,
        currentPageSize,
        isLoading,
        itemCount,
        pageCount,
        pageNumber,
        pageNumberInvalid,
        pageSize,
      },
    },
    since,
  } = state;

  return (
    <div class="container">
      <div class="mb-3 mt-3">
        {controls({
          translations,
          actions,
          section,
          state: {
            categories,
            categoryID: category ? category.id : undefined,
            clientID,
            loadingCategories,
            loadingPlaces,
            pageNumber,
            pageSize,
            since,
          },
        })}
      </div>
      <div class="mb-3 mt-3">
        {actionsOnSelected({ section, state, translations })}
      </div>
      {failed && (
        <div
          class="alert alert-danger animated pulse"
          key={`fetchPlacesFailed::${lastFailure}`}
          role="alert"
        >
          {message}
        </div>
      )}
      <div style="margin-bottom: 1rem;">
        {columnSelector({
          actions,
          disabled: loadingPlaces,
          section,
          state,
          translations,
        })}
      </div>
      <div class="position-relative">
        {list({ actions, section, state })}
        {regionLoading({
          state: {
            on: loadingPlaces,
          },
        })}
      </div>
      <div class="position-relative">
        {regionLoading({
          state: {
            on: isLoading,
          },
        })}
        <table class="col-12">
          <caption>
            {currentPageNumber > 0 && (
              <span class="caption">
                Locais
                <br />
                <b>
                  {new Intl.NumberFormat("pt-BR").format(
                    (currentPageNumber - 1) * currentPageSize + 1,
                  )}
                </b>{" "}
                a{" "}
                <b>
                  {new Intl.NumberFormat("pt-BR").format(
                    (currentPageNumber - 1) * currentPageSize + currentPageSize,
                  )}
                </b>{" "}
                {itemCount === undefined ? (
                  <span />
                ) : (
                  <span>
                    {" "}
                    de <b>
                      {new Intl.NumberFormat("pt-BR").format(itemCount)}
                    </b>{" "}
                  </span>
                )}
              </span>
            )}
          </caption>
        </table>
        {pagination({
          actions: {
            onChange: actions.fetchPlaces,
            setPagination: actions.setPagination,
          },
          section,
          state: {
            currentPageNumber,
            disabled: loadingPlaces,
            pageCount,
            pageNumber,
            pageNumberInvalid,
            pageSize,
          },
        })}
      </div>
    </div>
  );
};
